
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { RoomComponent } from './room.component';
import { DateMomentPipe } from 'libraries/date/dateMoment.pipe';
import { CancellationConditionsModule } from '../cancellation-conditions/cancellation-conditions.module';
import { DeltaPriceModule } from '../delta-price/delta-price.module';
import { PriceDetailsModule } from '../price-details/price-details.module';
import { MealPlanModule } from '../../../component/meal-plan/meal-plan.module';
import { ResortFeeComponent } from './resort-fee.component';
import { SalesInformationComponent } from './sales-information.component';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { RoomInformationsModule } from '../room-informations/room-informations.module';
import { RequestStatusModule } from '../request-status/request-status.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        PriceDetailsModule,
        CancellationConditionsModule,
        DeltaPriceModule,
        MealPlanModule,
        PricePipesModule,
        RoomInformationsModule,
        RequestStatusModule,
        FontAwesomeModule,
    ],
    exports: [
        RoomComponent,
    ],
    declarations: [
        RoomComponent,
        ResortFeeComponent,
        SalesInformationComponent,
    ],
    providers: [
        DateMomentPipe,
    ]
})
export class RoomModule { }
